var _excluded = ["emoji", "link", "onClose", "variant", "style"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import toast from 'react-hot-toast';
import { Toast } from '../../Toast';
import { ToastWrapper } from '../../ToastWrapper/ToastWrapper';
export var showToast = (children, params) => {
  var _dismiss = t => toast.dismiss(t.id);

  var _ref = params || {},
      {
    emoji,
    link,
    onClose,
    variant = 'light',
    style
  } = _ref,
      toastDefaultOptions = _objectWithoutProperties(_ref, _excluded);

  toast.custom(t => /*#__PURE__*/React.createElement(ToastWrapper, {
    dismissable: Boolean(onClose),
    dismiss: () => _dismiss(t)
  }, /*#__PURE__*/React.createElement(Toast, {
    variant: variant,
    link: link,
    emoji: emoji,
    closeable: Boolean(onClose),
    style: style,
    onClose: onClose ? () => {
      _dismiss(t);

      onClose === null || onClose === void 0 ? void 0 : onClose();
    } : undefined,
    isVisible: t.visible
  }, children)), toastDefaultOptions);
};
//# sourceMappingURL=showToast.js.map